import CryptoJS from 'crypto-js';

// Equivalent to: MD5CryptoServiceProvider objHashMD5 = new MD5CryptoServiceProvider();
// and: objDESCrypto.Key = byteHash;
const getMD5Key = strKey => CryptoJS.MD5(CryptoJS.enc.Utf8.parse(strKey));
/**
 * Encrypts a string using TripleDES with an MD5-hashed key (like your C# code).
 * @param {string} strToEncrypt - The string to encrypt.
 * @param {string} strKey - The key string (default: 'DES').
 * @returns {string} - The base64 encrypted string.
 */
export const encryptString = (strToEncrypt, strKey = 'DES') => {
  const md5Key = getMD5Key(strKey);
  const encrypted = CryptoJS.TripleDES.encrypt(strToEncrypt, md5Key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // Base64 string
};

/**
 * Decrypts a string encrypted with the above method.
 * @param {string} strEncrypted - The encrypted base64 string.
 * @param {string} strKey - The key string (default: 'DES').
 * @returns {string} - The decrypted string.
 */
export const decryptString = (strEncrypted, strKey = 'DES') => {
  try {
    const md5Key = getMD5Key(strKey);
    const decrypted = CryptoJS.TripleDES.decrypt(strEncrypted, md5Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return `Wrong Input. ${error?.message}`;
  }
};

const generateRandomString = length => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let randomString = '';
  for (let i = 0; i < length; i += 1) {
    const randomIndex = Math.floor(Math.random() * alphabet.length);
    randomString += alphabet.charAt(randomIndex);
  }
  return randomString;
};

const encode = str => {
  const hashedStr = btoa(btoa(str));
  const randomStr = generateRandomString(4);
  const updatedStr =
    hashedStr.substring(0, 4) + randomStr + hashedStr.substring(4);
  return updatedStr;
};

export { encode, generateRandomString };
